
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  privacyListing: [],
  privacyDetail: null
};

const privacyReducer = (state = initialState, action) => {
  // console.log("privacy  reducers------", state, action);
  switch (action.type) {
    case "ADD_PRIVACY_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_PRIVACY_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_PRIVACY_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_PRIVACY_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_PRIVACY_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_PRIVACY_REQUEST_SUCCESS":
      return {
        ...state,
        privacyListing: action.payload,
        loading: false,
      };


    case "GOT_PRIVACY_DETAIL":
      return {
        ...state,
        privacyDetail: action.payload,
      };
    default:
      return state;
  }
};

export default privacyReducer;
